import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/video/agriculture.mp4';
import _imports_1 from '@/assets/video/flood.mp4';
import _imports_2 from '@/assets/partner/2.webp';
import _imports_3 from '@/assets/partner/5.png';
import _imports_4 from '@/assets/partner/1.png';
import _imports_5 from '@/assets/partner/2.jpg';
import _imports_6 from '@/assets/partner/3.png';
import _imports_7 from '@/assets/partner/2.png';
import _imports_8 from '@/assets/partner/1.svg';
import _imports_9 from '@/assets/partner/1.webp';
import _imports_10 from '@/assets/partner/4.png';
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "video"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "video"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "porducts"
};
const _hoisted_7 = {
  class: "porductlist"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "text"
};
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = {
  class: "application"
};
const _hoisted_12 = {
  class: "applicationlist"
};
const _hoisted_13 = {
  class: "app"
};
const _hoisted_14 = {
  class: "app"
};
const _hoisted_15 = {
  class: "app"
};
const _hoisted_16 = {
  class: "app"
};
const _hoisted_17 = {
  class: "app"
};
const _hoisted_18 = {
  class: "app"
};
const _hoisted_19 = {
  class: "news"
};
const _hoisted_20 = {
  class: "news-container"
};
const _hoisted_21 = {
  class: "news-lists"
};
const _hoisted_22 = {
  class: "news-list"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  key: 0,
  class: "news-mark"
};
const _hoisted_25 = ["src"];
const _hoisted_26 = {
  class: "news-content"
};
const _hoisted_27 = {
  class: "top-content"
};
const _hoisted_28 = {
  class: "title"
};
const _hoisted_29 = {
  key: 0,
  class: "time"
};
const _hoisted_30 = {
  key: 1,
  class: "time"
};
const _hoisted_31 = ["innerHTML"];
const _hoisted_32 = {
  class: "news-list"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  key: 0,
  class: "news-mark"
};
const _hoisted_35 = ["src"];
const _hoisted_36 = {
  class: "news-content"
};
const _hoisted_37 = {
  class: "top-content"
};
const _hoisted_38 = {
  class: "title"
};
const _hoisted_39 = {
  key: 0,
  class: "time"
};
const _hoisted_40 = {
  key: 1,
  class: "time"
};
const _hoisted_41 = ["innerHTML"];
import axios from 'axios';
import { ref, onMounted, reactive, getCurrentInstance } from 'vue';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';
import app1 from '../../assets/app/1.png';
import app2 from '../../assets/app/2.png';
import app3 from '../../assets/app/3.png';
import app4 from '../../assets/app/4.png';
import app5 from '../../assets/app/5.png';
import app6 from '../../assets/app/6.png';
import { useRouter } from "vue-router";
import { avatarProps } from 'element-plus';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const activeName = ref('first');
    const data = reactive({
      bannerList: [],
      productTechnologyList0: [],
      productTechnologyList1: [],
      productTechnologyList2: [],
      schemeList: [],
      articleList: [],
      articleList0: [],
      articleList1: []
    });
    const baseUrl = getCurrentInstance().appContext.config.globalProperties.baseUrl;
    onMounted(() => {
      getBannerList();
      getProductTechnologyList();
      getSchemeList();
      getArticleList();
    });
    const handleLinkTo = id => {
      router.push(`/application${id}`);
    };
    const handleProductList = () => {
      router.push("/productList");
    };
    const handleProductInfo = id => {
      router.push({
        path: "/productInfo",
        query: {
          id: id
        }
      });
    };
    const handleApp = id => {
      router.push({
        path: `/application${id}`
        // query:{
        //   id: id
        // }
      });
    };
    const handleNews = id => {
      router.push({
        path: "/news",
        query: {
          id: id
        }
      });
    };
    const getBannerList = url => {
      axios.get(`${baseUrl}/lechi/cms/article/list?pageNum=1&pageSize=10&articleType=banner`, {}).then(res => {
        if (res.data.code == 200) {
          data.bannerList = res.data.rows;
        }
      }).catch(error => {});
    };
    const getProductTechnologyList = url => {
      axios.get(`${baseUrl}/lechi/cms/article/list?pageNum=1&pageSize=6&articleType=productTechnology&state=0`, {}).then(res => {
        if (res.data.code == 200) {
          data.productTechnologyList0 = res.data.rows;
        }
      }).catch(error => {});
      axios.get(`${baseUrl}/lechi/cms/article/list?pageNum=1&pageSize=6&articleType=productTechnology&state=1`, {}).then(res => {
        if (res.data.code == 200) {
          data.productTechnologyList1 = res.data.rows;
        }
      }).catch(error => {});
      axios.get(`${baseUrl}/lechi/cms/article/list?pageNum=1&pageSize=6&articleType=productTechnology&state=2`, {}).then(res => {
        if (res.data.code == 200) {
          data.productTechnologyList2 = res.data.rows;
        }
      }).catch(error => {});
    };
    const getSchemeList = url => {
      axios.get(`${baseUrl}/lechi/cms/article/list?pageNum=1&pageSize=6&articleType=scheme`, {}).then(res => {
        if (res.data.code == 200) {
          data.schemeList = res.data.rows;
        }
      }).catch(error => {});
    };
    const getArticleList = url => {
      axios.get(`${baseUrl}/lechi/cms/article/list?pageNum=1&pageSize=10&articleType=news`, {}).then(res => {
        if (res.data.code == 200) {
          data.articleList = res.data.rows.filter(item => item.articleType == 'news');
          data.articleList.forEach(item => {
            if (item.updateTime) {
              item.updateTime = item.updateTime.substring(0, 10);
            }
            item.createTime = item.createTime.substring(0, 10);
          });
          data.articleList0 = data.articleList.filter(item => item.state == 0);
          data.articleList1 = data.articleList.filter(item => item.state == 1);
        }
      }).catch(error => {});
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Header), _createVNode(_component_el_carousel, {
        interval: 10000,
        "motion-blur": "",
        height: "960px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[9] || (_cache[9] = _createElementVNode("h3", null, "科技创新", -1)), _cache[10] || (_cache[10] = _createElementVNode("div", null, "改变未来农业发展", -1)), _createVNode(_component_el_button, {
            round: "",
            style: {
              "height": "40px",
              "width": "150px",
              "font-size": "16px"
            },
            onClick: _cache[0] || (_cache[0] = $event => handleLinkTo(1))
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("了解详情")])),
            _: 1
          })]), _cache[11] || (_cache[11] = _createElementVNode("video", {
            src: _imports_0,
            muted: "",
            autoplay: "",
            loop: "",
            style: {
              "width": "101%",
              "height": "100%",
              "border": "none"
            }
          }, null, -1))])]),
          _: 1
        }), _createVNode(_component_el_carousel_item, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[13] || (_cache[13] = _createElementVNode("h3", null, "气象科技", -1)), _cache[14] || (_cache[14] = _createElementVNode("div", null, "防灾减灾的第一道防线", -1)), _createVNode(_component_el_button, {
            round: "",
            style: {
              "height": "40px",
              "width": "150px",
              "font-size": "16px"
            },
            onClick: _cache[1] || (_cache[1] = $event => handleLinkTo(5))
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("了解详情")])),
            _: 1
          })]), _cache[15] || (_cache[15] = _createElementVNode("video", {
            src: _imports_1,
            muted: "",
            autoplay: "",
            loop: "",
            style: {
              "width": "101%",
              "height": "100%",
              "border": "none"
            }
          }, null, -1))])]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_6, [_cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "porduct-title"
      }, "产品技术", -1)), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.productTechnologyList0, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "porduct",
          onClick: $event => handleProductInfo(item.catalog1)
        }, [_createVNode(_component_el_image, {
          style: {
            "width": "200px"
          },
          src: item.coverImg,
          lazy: ""
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("h2", _hoisted_10, _toDisplayString(item.title), 1), _createVNode(_component_el_button, {
          type: "primary",
          style: {
            "width": "100%",
            "height": "40px",
            "font-size": "16px"
          }
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("产品详情")])),
          _: 1
        })])], 8, _hoisted_8);
      }), 128))]), _createVNode(_component_el_button, {
        round: "",
        style: {
          "margin": "20px auto",
          "display": "block",
          "width": "120px"
        },
        onClick: handleProductList
      }, {
        default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("了解更多")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_11, [_cache[25] || (_cache[25] = _createElementVNode("div", {
        class: "porduct-title"
      }, "系统方案", -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[19] || (_cache[19] = _createElementVNode("div", {
        class: "title"
      }, "农业气象观测", -1)), _createElementVNode("div", {
        class: "img",
        onClick: _cache[2] || (_cache[2] = $event => handleApp(1))
      }, [_createVNode(_component_el_image, {
        style: {
          "width": "375px"
        },
        src: _unref(app1),
        lazy: ""
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_14, [_cache[20] || (_cache[20] = _createElementVNode("div", {
        class: "title"
      }, "气象科普观测", -1)), _createElementVNode("div", {
        class: "img",
        onClick: _cache[3] || (_cache[3] = $event => handleApp(2))
      }, [_createVNode(_component_el_image, {
        style: {
          "width": "375px"
        },
        src: _unref(app2),
        lazy: ""
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_15, [_cache[21] || (_cache[21] = _createElementVNode("div", {
        class: "title"
      }, "交通气象监测", -1)), _createElementVNode("div", {
        class: "img",
        onClick: _cache[4] || (_cache[4] = $event => handleApp(3))
      }, [_createVNode(_component_el_image, {
        style: {
          "width": "375px"
        },
        src: _unref(app3),
        lazy: ""
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_16, [_cache[22] || (_cache[22] = _createElementVNode("div", {
        class: "title"
      }, "生态环境监测", -1)), _createElementVNode("div", {
        class: "img",
        onClick: _cache[5] || (_cache[5] = $event => handleApp(4))
      }, [_createVNode(_component_el_image, {
        style: {
          "width": "375px"
        },
        src: _unref(app4),
        lazy: ""
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_17, [_cache[23] || (_cache[23] = _createElementVNode("div", {
        class: "title"
      }, "城市内涝监测", -1)), _createElementVNode("div", {
        class: "img",
        onClick: _cache[6] || (_cache[6] = $event => handleApp(5))
      }, [_createVNode(_component_el_image, {
        style: {
          "width": "375px"
        },
        src: _unref(app5),
        lazy: ""
      }, null, 8, ["src"])])]), _createElementVNode("div", _hoisted_18, [_cache[24] || (_cache[24] = _createElementVNode("div", {
        class: "title"
      }, "水文气象监测", -1)), _createElementVNode("div", {
        class: "img",
        onClick: _cache[7] || (_cache[7] = $event => handleApp(6))
      }, [_createVNode(_component_el_image, {
        style: {
          "width": "375px"
        },
        src: _unref(app6),
        lazy: ""
      }, null, 8, ["src"])])])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_cache[28] || (_cache[28] = _createElementVNode("div", {
        class: "porduct-title"
      }, "新闻中心", -1)), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_cache[26] || (_cache[26] = _createElementVNode("div", {
        class: "news-type"
      }, "行业动态", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.articleList1, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [item.state == 1 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "news-item",
          onClick: $event => handleNews(item.id)
        }, [index == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_24, "NEW")) : _createCommentVNode("", true), _createElementVNode("img", {
          class: "coverImg",
          src: item.coverImg
        }, null, 8, _hoisted_25), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(item.title), 1), item.updateTime ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(item.updateTime), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(item.createTime), 1))]), _createElementVNode("div", {
          class: "content",
          innerHTML: item.mainContent
        }, null, 8, _hoisted_31)])], 8, _hoisted_23)) : _createCommentVNode("", true)], 64);
      }), 256))]), _createElementVNode("div", _hoisted_32, [_cache[27] || (_cache[27] = _createElementVNode("div", {
        class: "news-type"
      }, "企业新闻", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.articleList0, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, null, [item.state == 0 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "news-item",
          onClick: $event => handleNews(item.id)
        }, [index == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_34, "NEW")) : _createCommentVNode("", true), _createElementVNode("img", {
          class: "coverImg",
          src: item.coverImg
        }, null, 8, _hoisted_35), _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString(item.title), 1), item.updateTime ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(item.updateTime), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(item.createTime), 1))]), _createElementVNode("div", {
          class: "content",
          innerHTML: item.mainContent
        }, null, 8, _hoisted_41)])], 8, _hoisted_33)) : _createCommentVNode("", true)], 64);
      }), 256))])])])]), _cache[29] || (_cache[29] = _createStaticVNode("<div class=\"cooperative-partner\" data-v-0297679c><div class=\"partner-container\" data-v-0297679c><div class=\"porduct-title\" style=\"color:#fff !important;\" data-v-0297679c>合作伙伴</div><div class=\"partner-list\" data-v-0297679c><div class=\"img\" data-v-0297679c><img width=\"100\" height=\"100\" src=\"" + _imports_2 + "\" data-v-0297679c></div><div class=\"img\" data-v-0297679c><img width=\"200\" height=\"45\" src=\"" + _imports_3 + "\" data-v-0297679c></div><div class=\"img\" data-v-0297679c><img width=\"200\" height=\"41\" src=\"" + _imports_4 + "\" data-v-0297679c></div><div class=\"img\" data-v-0297679c><img width=\"100\" height=\"100\" src=\"" + _imports_5 + "\" data-v-0297679c></div><div class=\"img\" data-v-0297679c><img width=\"200\" height=\"49\" src=\"" + _imports_6 + "\" data-v-0297679c></div><div class=\"img\" data-v-0297679c><img width=\"200\" height=\"49\" src=\"" + _imports_7 + "\" data-v-0297679c></div><div class=\"img\" data-v-0297679c><img width=\"200\" height=\"49\" src=\"" + _imports_8 + "\" data-v-0297679c></div><div class=\"img\" data-v-0297679c><img width=\"100\" height=\"100\" src=\"" + _imports_9 + "\" data-v-0297679c></div><div class=\"img\" data-v-0297679c><img width=\"200\" height=\"52\" src=\"" + _imports_10 + "\" data-v-0297679c></div></div></div></div>", 1)), _createVNode(Footer)]);
    };
  }
};